import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { AuthSignedInUserResponseProps } from '../../../../types/user';
import { DEFAULT_AUTHENTICATED_APP_ROUTE } from '../../../router/routePathNames';

export const useRedirectToHomeIfLoginDataIsNotAvailable = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const loginData = location.state?.loginData as
    | AuthSignedInUserResponseProps
    | undefined;

  useEffect(() => {
    if (!loginData) {
      navigate(DEFAULT_AUTHENTICATED_APP_ROUTE, { replace: true });
    }
  }, []);
};
